
import { DOCUMENT, Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PlatformService } from '../platform/platform.service';
import { StoreConfigurationRepositoryService } from '../store-configuration/store-configuration-repository.service';

const START = `<!-- Start of Meta Tags -->`;
const END = `<!-- End of Meta Tags -->`;
export const SERVICE_KEY = environment.googleRecaptchaKey;
const RECAPTCHA_SCRIPT = `<script id="recaptcha" src="https://www.google.com/recaptcha/enterprise.js?render=${SERVICE_KEY}"></script>`;

enum ScriptId {
  HEAD = 'head-script',
  RECAPTCHA = 'recaptcha-script',
  BODY_START = 'body-start-script',
  BODY_END = 'body-end-script',
  FOOTER = 'footer-script'
}
@Injectable({
  providedIn: 'root'
})
export class InjectScriptsService {
  private document = inject<Document>(DOCUMENT);
  private platformService = inject(PlatformService);
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);


  SCRIPT_IDS = {
    HEAD: ScriptId.HEAD,
    RECAPTCHA: ScriptId.RECAPTCHA,
    BODY_START: ScriptId.BODY_START,
    BODY_END: ScriptId.BODY_END,
    FOOTER: ScriptId.FOOTER
  };

  init() {
    try {
      this.injectScript(ScriptId.HEAD);
      this.injectScript(ScriptId.BODY_START);
      this.injectScript(ScriptId.BODY_END);
      this.injectScript(ScriptId.FOOTER);
    } catch (error) {
    }
  }

  addRecaptchaScript() {
    try {
      this.injectScript(ScriptId.RECAPTCHA);
    } catch (error) {
      // Handle error silently
    }
  }

  private injectScript(scriptId: string) {
    try {
      if (!this.platformService.isBrowser()) {
        return;
      }

      const scriptElement = this.document.getElementById(scriptId) as HTMLScriptElement;
      if (scriptElement) {
        return;
      }

      const preparedScript = this.prepareScript(scriptId);
      // string is not a valid script
      if (!preparedScript) {
        return;
      }


      const fragment = document.createRange().createContextualFragment(preparedScript);
      this.appendScript(scriptId, fragment);
    } catch (error) {
      // Handle error silently
    }
  }

  private prepareScript(scriptId: string): string | undefined {
    try {
      switch (scriptId) {
        case ScriptId.HEAD:
          {
            const storeConfig = this.storeConfigurationRepositoryService.storeConfigurations();
            const { header_tags: { script = '' } = {} } = storeConfig || {};
            return this.removeString(script, START, END);
          }
          break;

        case ScriptId.RECAPTCHA:
          {
            return RECAPTCHA_SCRIPT;
          }
          break;
        case ScriptId.BODY_START:
          {
            const storeConfig = this.storeConfigurationRepositoryService.storeConfigurations();
            const { body_start_tags: { script = '' } = {} } = storeConfig || {};
            return script;
          }
          break;
        case ScriptId.BODY_END:
          {
            const storeConfig = this.storeConfigurationRepositoryService.storeConfigurations();
            const { body_end_tags: { script = '' } = {} } = storeConfig || {};
            return script;
          }
          break;
        case ScriptId.FOOTER:
          {
            const storeConfig = this.storeConfigurationRepositoryService.storeConfigurations();
            const { footer_tags: { script = '' } = {} } = storeConfig || {};
            return script;
          }
          break;
        default:
          return undefined;
      }
    } catch (error) {
      // Handle error silently
      return undefined;
    }
  }

  private appendScript(scriptId: string, scriptElement: DocumentFragment) {
    try {
      switch (scriptId) {
        case ScriptId.HEAD:
          {
            this.document.head.appendChild(scriptElement);
          }
          break;
        case ScriptId.RECAPTCHA:
          {
            this.document.head.appendChild(scriptElement);
          }
          break;
        case ScriptId.BODY_START:
          {
            this.document.body.prepend(scriptElement);
          }
          break;
        case ScriptId.BODY_END:
          {
            this.document.body.append(scriptElement);
          }
          break;
        case ScriptId.FOOTER:
          {
            if (this.document.lastChild) {
              this.document.lastChild.appendChild(scriptElement);
            }
          }
          break;
      }
    } catch (error) {
      // Handle error silently
    }
  }

  private removeString(input: string, prefix: string, suffix: string) {
    const i = input.indexOf(prefix);
    const j = input.indexOf(suffix) + suffix.length;
    if (i > 0 && j > i) {
      return input.substring(0, i).concat(input.substring(j));
    }
    return input;
  }


}
